import React, { useState } from 'react';
import BlogCard from '../components/BlogCard';
import { useData } from '../context/DataContext';

const Blogs = () => {
  const { blogs } = useData();
  const [activeCategory, setActiveCategory] = useState('All');

  const categories = ['All', ...Array.from(new Set(blogs.map((b) => b.category)))];

  const filteredBlogs = activeCategory === 'All'
    ? blogs
    : blogs.filter((b) => b.category === activeCategory);

  return (
    <div className="blogs-page">
      <div className="categories-bar">
        {categories.map((cat) => (
          <button
            key={cat}
            className={`category-btn ${activeCategory === cat ? 'active' : ''}`}
            onClick={() => setActiveCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="blogs-tile-grid">
        {filteredBlogs.map((blog) => (
          <BlogCard key={blog.id} blog={blog} />
        ))}
      </div>

      {filteredBlogs.length === 0 && (
        <div className="empty-state">
          <div className="icon">~</div>
          <h3>No posts yet in this category</h3>
          <p>Check back soon or explore other categories.</p>
        </div>
      )}
    </div>
  );
};

export default Blogs;
